var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-dialog",
    {
      attrs: { "max-width": "960", scrollable: "" },
      on: { input: _vm.onDialogInput },
      model: {
        value: _vm.showDialog,
        callback: function($$v) {
          _vm.showDialog = $$v
        },
        expression: "showDialog"
      }
    },
    [
      _c(
        "v-card",
        [
          _c("v-card-title", [
            _c("span", [
              _vm._v(
                _vm._s(
                  _vm.mode === "edit"
                    ? "Muokkaa tapahtumasuodatinta"
                    : "Uusi tapahtumasuodatin"
                )
              )
            ])
          ]),
          _c("v-divider"),
          _c(
            "v-card-text",
            { staticStyle: { "max-height": "78vh" } },
            [
              _c(
                "v-form",
                {
                  ref: "form",
                  model: {
                    value: _vm.formValid,
                    callback: function($$v) {
                      _vm.formValid = $$v
                    },
                    expression: "formValid"
                  }
                },
                [
                  _c(
                    "v-row",
                    { staticClass: "mt-2" },
                    [
                      _c(
                        "v-col",
                        { attrs: { cols: "12", sm: "6" } },
                        [
                          _c("v-text-field", {
                            attrs: {
                              label: "Suodattimen nimi",
                              rules: _vm.filterNameRules,
                              outlined: "",
                              dense: ""
                            },
                            model: {
                              value: _vm.localFilter.filterName,
                              callback: function($$v) {
                                _vm.$set(_vm.localFilter, "filterName", $$v)
                              },
                              expression: "localFilter.filterName"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "v-row",
                    { staticClass: "mt-0" },
                    [
                      _c(
                        "v-col",
                        { attrs: { cols: "12", sm: "4" } },
                        [
                          _c("v-switch", {
                            staticClass: "mt-0",
                            attrs: {
                              label: "Väliaikainen suodatin",
                              "hide-details": ""
                            },
                            model: {
                              value: _vm.localFilter.isTemporary,
                              callback: function($$v) {
                                _vm.$set(_vm.localFilter, "isTemporary", $$v)
                              },
                              expression: "localFilter.isTemporary"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "v-col",
                        { attrs: { cols: "12", sm: "4" } },
                        [
                          _c("v-switch", {
                            staticClass: "mt-0",
                            attrs: {
                              label: "Myyntilaskutukseen",
                              "hide-details": ""
                            },
                            model: {
                              value: _vm.localFilter.isForSalesInvoicing,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.localFilter,
                                  "isForSalesInvoicing",
                                  $$v
                                )
                              },
                              expression: "localFilter.isForSalesInvoicing"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "v-col",
                        { attrs: { cols: "12", sm: "4" } },
                        [
                          _c("v-switch", {
                            staticClass: "mt-0",
                            attrs: {
                              label: "Ostolaskutukseen",
                              "hide-details": ""
                            },
                            model: {
                              value: _vm.localFilter.isForPurchaseInvoicing,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.localFilter,
                                  "isForPurchaseInvoicing",
                                  $$v
                                )
                              },
                              expression: "localFilter.isForPurchaseInvoicing"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "v-row",
                    { staticClass: "mt-4" },
                    [
                      _c(
                        "v-col",
                        { attrs: { cols: "12" } },
                        [
                          _c("v-switch", {
                            staticClass: "mt-0",
                            attrs: {
                              label:
                                "Käytä suhteellista aikaväliä (korvaa hakuehtojen päivämäärärajaukset)",
                              "hide-details": ""
                            },
                            model: {
                              value: _vm.useRelativeTimeRange,
                              callback: function($$v) {
                                _vm.useRelativeTimeRange = $$v
                              },
                              expression: "useRelativeTimeRange"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c("v-expand-transition", [
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.useRelativeTimeRange,
                            expression: "useRelativeTimeRange"
                          }
                        ]
                      },
                      [
                        _c(
                          "v-row",
                          { staticClass: "mt-2" },
                          [
                            _c(
                              "v-col",
                              { attrs: { cols: "12", sm: "4" } },
                              [
                                _c("v-select", {
                                  attrs: {
                                    items: _vm.rangeTypeOptions,
                                    "item-text": "text",
                                    "item-value": "value",
                                    label: "Aikavälin tyyppi",
                                    outlined: "",
                                    dense: ""
                                  },
                                  model: {
                                    value:
                                      _vm.localFilter.relativeTimeRange
                                        .rangeType,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.localFilter.relativeTimeRange,
                                        "rangeType",
                                        $$v
                                      )
                                    },
                                    expression:
                                      "localFilter.relativeTimeRange.rangeType"
                                  }
                                })
                              ],
                              1
                            ),
                            _c(
                              "v-col",
                              { attrs: { cols: "6", sm: "4" } },
                              [
                                _c("v-text-field", {
                                  attrs: {
                                    label: "Alkupäivä (1–31)",
                                    type: "number",
                                    min: "1",
                                    max: "31",
                                    clearable: "",
                                    outlined: "",
                                    dense: "",
                                    hint: "Tyhjä = Ei rajoitusta",
                                    "persistent-hint": ""
                                  },
                                  model: {
                                    value:
                                      _vm.localFilter.relativeTimeRange
                                        .startDay,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.localFilter.relativeTimeRange,
                                        "startDay",
                                        _vm._n($$v)
                                      )
                                    },
                                    expression:
                                      "localFilter.relativeTimeRange.startDay"
                                  }
                                })
                              ],
                              1
                            ),
                            _c(
                              "v-col",
                              { attrs: { cols: "6", sm: "4" } },
                              [
                                _c("v-text-field", {
                                  attrs: {
                                    label: "Loppupäivä (1–31)",
                                    type: "number",
                                    min: "1",
                                    max: "31",
                                    clearable: "",
                                    outlined: "",
                                    dense: "",
                                    hint:
                                      "Tyhjä = kuun loppuun · Päivän loppu (23:59)",
                                    "persistent-hint": ""
                                  },
                                  model: {
                                    value:
                                      _vm.localFilter.relativeTimeRange
                                        .cutoffDay,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.localFilter.relativeTimeRange,
                                        "cutoffDay",
                                        _vm._n($$v)
                                      )
                                    },
                                    expression:
                                      "localFilter.relativeTimeRange.cutoffDay"
                                  }
                                })
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ]),
                  _c("v-divider", { staticClass: "my-4" }),
                  _c("div", { staticClass: "subtitle-1 mb-2" }, [
                    _vm._v("Hakuehdot")
                  ]),
                  _c("TransportEventRangeSearchForm", {
                    ref: "searchForm",
                    attrs: { searchParams: _vm.localFilter.queryFilter }
                  })
                ],
                1
              ),
              _vm.errorMessage
                ? _c(
                    "v-alert",
                    {
                      staticClass: "mt-4",
                      attrs: { type: "error", dense: "" }
                    },
                    [_vm._v(" " + _vm._s(_vm.errorMessage) + " ")]
                  )
                : _vm._e()
            ],
            1
          ),
          _c("v-divider"),
          _c(
            "v-card-actions",
            { staticClass: "pb-4" },
            [
              _c("v-spacer"),
              _c(
                "v-btn",
                {
                  attrs: { color: "primary", loading: _vm.saving },
                  on: {
                    click: function($event) {
                      _vm.mode === "edit"
                        ? _vm.submit("save")
                        : _vm.submit("create")
                    }
                  }
                },
                [
                  _vm._v(
                    " " +
                      _vm._s(
                        _vm.mode === "edit"
                          ? _vm.$t("common.save")
                          : _vm.$t("common.create")
                      ) +
                      " "
                  )
                ]
              ),
              _c(
                "v-btn",
                {
                  staticClass: "ml-4",
                  on: {
                    click: function($event) {
                      return _vm.$emit("cancel")
                    }
                  }
                },
                [_vm._v(" " + _vm._s(_vm.$t("common.cancel")) + " ")]
              ),
              _c("v-spacer")
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }